import { jsx as _jsx } from "react/jsx-runtime";
import { CardText } from "./index.js";
export const CardDescription = ({ children, ...props }) => children ? _jsx(CardText, { ...props, children: children }) : null;
//# sourceMappingURL=CardDescription.js.map